// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__10kQG","xlsWrapper":"icon_xlsWrapper__332qk","xlsIcon":"icon_xlsIcon__iMeKV"};